import React from 'react';
import { ClipboardList, Save, ArrowLeft, Search, PlusCircle } from 'lucide-react';

const TastingRoomInventoryDetailToolbar = ({ 
    onSave, 
    onBack, 
    isSaving,
    hasChanges,
    onAddItem,
    searchTerm,
    onSearchChange 
}) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <ClipboardList size={24} className="me-2" />
                        <h5 className="mb-0">Tasting Room Inventory Count</h5>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search items..."
                                value={searchTerm}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onAddItem}
                                title="Add New Item"
                            >
                                <PlusCircle size={18} className="me-2" />
                                Add Item
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onBack}
                                title="Back to Inventory Logs"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button
                                className="btn btn-outline-primary"
                                onClick={onSave}
                                disabled={isSaving || !hasChanges}
                                title={isSaving ? 'Saving...' : 'Save Changes'}
                            >
                                <Save size={18} className="me-2" />
                                {isSaving ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default TastingRoomInventoryDetailToolbar;